export const favorites = {
  title: "Τα αγαπημένα μου",
  subtitle: "{{count}} αποθηκευμένα καταλύματα",
  countries: "Χώρες",
  cities: "Πόλεις",
  emptyTitle: "Κανένα αγαπημένο προς το παρόν",
  emptyFiltered:
    "Δοκιμάστε να τροποποιήσετε τα φίλτρα σας για να δείτε τα αγαπημένα σας.",
  emptyState:
    "Εξερευνήστε τα μοναδικά καταλύματά μας και προσθέστε τα στα αγαπημένα για να τα βρείτε εδώ.",
  noFavoritesYet: "Κανένα αγαπημένο προς το παρόν",
  exploreMembersMap: "Εξερευνήστε τον χάρτη μελών για να βρείτε καταλύματα",
  exploreMap: "Εξερεύνηση χάρτη",
  backToHome: "Επιστροφή στην αρχική",
  howToAddFavorites: "Πώς να προσθέσετε αγαπημένα;",
  step1: "Πηγαίνετε στον",
  step2: "χάρτη μελών",
  step3: "και κάντε κλικ στην καρδιά",
  step3End: "για να προσθέσετε ένα κατάλυμα στα αγαπημένα σας",
  membersMapLink: "Χάρτης μελών",
  properties: "ιδιοκτησίες",
  selected: "επιλεγμένες",
  compare: "Σύγκριση",
  actions: "Ενέργειες",
  contact: "Επικοινωνία",
  exchange: "Πρόταση ανταλλαγής",
  removeFromFavorites: "Αφαίρεση από τα αγαπημένα",
  removeFromComparison: "Αφαίρεση από τη σύγκριση",
  owner: "Ιδιοκτήτης",
  ratingLabel: "Βαθμολογία",
  exchangesLabel: "Ανταλλαγές",
  exchangesCount: "ανταλλαγές",
  exchangesCompleted: "ολοκληρωμένες ανταλλαγές",
  capacityLabel: "Χωρητικότητα",
  guestsCount: "ταξιδιώτες",
  numberOfRooms: "δωμάτια",
  roomsCount: "δωμάτια",
  onlineStatus: "Συνδεδεμένος",
  onlineBadge: "Συνδεδεμένος",
  verifiedStatus: "Επαληθευμένος",
  verifiedBadge: "Επαληθευμένος",
  no: "Όχι",
};
